export default __webpack_public_path__ + "static/media/item5.b20a6478.png";